// Canonical source for KB article links referenced from more than one page's
// InfoTooltip, per COCKPIT.md 2.3 (one canonical source for help text).

export const FOUR_FIVE_FOUR_CALENDAR_ARTICLE_URL =
  'https://hd.jira.ampersandbrands.com/servicedesk/customer/portal/2/article/113180673';

export const FOUR_FIVE_FOUR_CALENDAR_TOOLTIP =
  'Months and weeks follow the retail 4-5-4 calendar, so July runs Jul 5 - Aug 1 this year. Tap to see how it works.';
